import { Reducer } from 'redux';
import { PrintModelState, PrintModelTypes } from './types';

const INITIAL_STATE: PrintModelState = {
  printModelData: {
    id: '',
    name: '',
    operation: '',
    blocks: '',
    status: 0,
    createdAt: '',
    updatedAt: '',
    transportOperatorId: '',
  },
  printModelsList: [],
  error: false,
  loading: false,
  };

const reducer: Reducer<PrintModelState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // CASES LIST_PRINT_MODELS
    case PrintModelTypes.LIST_PRINT_MODELS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        printModelsList: INITIAL_STATE.printModelsList,
      };
    case PrintModelTypes.LIST_PRINT_MODELS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        printModelsList: action.payload.printModelsList,
        totalCount: action.payload.totalCount,
      };
    case PrintModelTypes.LIST_PRINT_MODELS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // CASES UPDATE_PRINT_MODEL
    case PrintModelTypes.UPDATE_PRINT_MODEL_REQUEST:
      return { ...state, loading: true, error: false };
    case PrintModelTypes.UPDATE_PRINT_MODEL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        printModelData: action.payload.printModelData,
      };
    case PrintModelTypes.UPDATE_PRINT_MODEL_FAILURE:
      return { ...state, loading: false, error: true };

    // CASES DELETE PRINT MODEL
    case PrintModelTypes.DELETE_PRINT_MODEL_REQUEST:
      return { 
        ...state, 
        loading: true,
         error: false 
    };
    case PrintModelTypes.DELETE_PRINT_MODEL_SUCCESS:
      return { 
        ...state, 
        loading: false, 
        error: false 
    };
    case PrintModelTypes.DELETE_PRINT_MODEL_FAILURE:
      return { 
        ...state, 
        loading: false, 
        error: true 
    };

    // CASES CREATE_PRINT_MODEL
    case PrintModelTypes.CREATE_PRINT_MODEL_REQUEST:
      return { 
        ...state, 
        loading: true, 
        error: false 
    };
    case PrintModelTypes.CREATE_PRINT_MODEL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        printModelData: action.payload.printModelData,
      };
    case PrintModelTypes.CREATE_PRINT_MODEL_FAILURE:
      return { ...state, loading: false, error: true }; 

    default:
      return state;
  }
};

export default reducer;
